import { rem } from 'polished'

import { css } from '../'
import { breakpoints } from '../breakpoints'
import { Size, SizeName } from '../size'

export interface HorizontalMarginProps {
  marginRight?: SizeName
  marginLeft?: SizeName
}

export interface VerticalMarginProps {
  marginTop?: SizeName
  marginBottom?: SizeName
}

export interface MarginDesktopProps {
  marginTopDesktop?: SizeName
  marginBottomDesktop?: SizeName

  marginRightDesktop?: SizeName
  marginLeftDesktop?: SizeName
}

export interface MarginTabletProps {
  marginTopTablet?: SizeName
  marginBottomTablet?: SizeName

  marginRightTablet?: SizeName
  marginLeftTablet?: SizeName
}

export const horizontalMarginsCss = css`
  margin-right: ${(p: HorizontalMarginProps) =>
    p.marginRight && rem(Size[p.marginRight])};

  margin-left: ${(p: HorizontalMarginProps) =>
    p.marginLeft && rem(Size[p.marginLeft])};
`

export const verticalMarginsCss = css`
  margin-top: ${(p: VerticalMarginProps) =>
    p.marginTop && rem(Size[p.marginTop])};

  margin-bottom: ${(p: VerticalMarginProps) =>
    p.marginBottom && rem(Size[p.marginBottom])};
`

export const marginsDesktopCss = css`
  @media (min-width: ${breakpoints.desktop}px) {
    margin-right: ${(p: MarginDesktopProps) =>
      p.marginRightDesktop && rem(Size[p.marginRightDesktop])};

    margin-left: ${(p: MarginDesktopProps) =>
      p.marginLeftDesktop && rem(Size[p.marginLeftDesktop])};
    margin-top: ${(p: MarginDesktopProps) =>
      p.marginTopDesktop && rem(Size[p.marginTopDesktop])};

    margin-bottom: ${(p: MarginDesktopProps) =>
      p.marginBottomDesktop && rem(Size[p.marginBottomDesktop])};
  }
`
export const marginsTabletCss = css`
  @media (min-width: ${breakpoints.tablet}px) {
    margin-right: ${(p: MarginTabletProps) =>
      p.marginRightTablet && rem(Size[p.marginRightTablet])};

    margin-left: ${(p: MarginTabletProps) =>
      p.marginLeftTablet && rem(Size[p.marginLeftTablet])};
    margin-top: ${(p: MarginTabletProps) =>
      p.marginTopTablet && rem(Size[p.marginTopTablet])};

    margin-bottom: ${(p: MarginTabletProps) =>
      p.marginBottomTablet && rem(Size[p.marginBottomTablet])};
  }
`
